import { Icon } from '@cb/apricot-react'
import { USER_PROMPT_MODAL_UPDATE } from '../constants'

function Available({ firstTime, endRangeDate, userPromptType }) {
  return firstTime ? (
    <>
      <h1 className="cb-margin-bottom-16 cb-font-weight-regular">
        Choose a Recipient for Your Free AP Score Report
      </h1>
      {userPromptType === USER_PROMPT_MODAL_UPDATE ? (
        <p>
          <Icon
            name="exclamation"
            circular
            color="red1"
            style={{ display: 'inline-block', top: '8px' }}
          />{' '}
          The recipient you previously selected is no longer valid. Please select a new recipient.
        </p>
      ) : null}
      <p>
        Each year you take AP Exams, you can have your AP score report sent for free to one
        recipient (a college, university, or scholarship organization). Your official score report
        includes the scores from all AP Exams taken this year and any AP Exams you&#39;ve previously
        taken, along with certain demographic information about you and other information you
        provide during testing. Schools use your official score report to determine credit or
        placement, if applicable. Colleges, universities, and scholarship programs that you send
        your score to may also use your information and official score report to contact you with
        information about admissions, educational, financial aid, and scholarship opportunities.
      </p>
      <p>
        To send your score report, start typing in the name of a college or organization, then
        choose from the drop-down menu. This year&#39;s deadline to use your one free score send is{' '}
        <strong>{endRangeDate}</strong>. Your score report will be sent in July.
      </p>
    </>
  ) : (
    <>
      <h1 className="cb-margin-bottom-16 cb-font-weight-regular">
        College to receive your AP score report
      </h1>
      <p>
        Each year you take AP Exams, you can have your AP score report sent for free to one
        recipient (a college, university, or scholarship organization). Your official score report
        includes the scores from all AP Exams taken this year and any AP Exams you&#39;ve previously
        taken, along with certain demographic information about you and other information you
        provide during testing. Schools use your official score report to determine credit or
        placement, if applicable. Colleges, universities, and scholarship programs that you send
        your score to may also use your information and official score report to contact you with
        information about admissions, educational, financial aid, and scholarship opportunities.
      </p>
    </>
  )
}

export default Available
